import React from 'react';
import LocationTemplate from './LocationTemplate';

const ChocowinityPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Chocowinity"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27817"]}
      latitude={35.5168}
      longitude={-77.0864}
      population={820}
      historicalFact="Name derived from a Native American word meaning 'fish from muddy water,' incorporated in 1889."
      nearbyTowns={[
        "Washington, NC",
        "Grimesland, NC",
        "Bath, NC",
        "Aurora, NC",
        "Greenville, NC",
        "Simpson, NC",
        "Pinetown, NC",
        "Edward, NC"
      ]}
    />
  );
};

export default ChocowinityPage;